function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m240 384c-79.527344 0-144-64.472656-144-144s64.472656-144 144-144 144 64.472656 144 144c-.09375 79.492188-64.507812 143.90625-144 144zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m232 432h16v48h-16zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m232 0h16v48h-16zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m329.070312 410.273438 13.855469-8 24 41.570312-13.855469 8zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m113.078125 36.160156 13.855469-8 24 41.570313-13.859375 8zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m402.28125 342.925781 8-13.855469 41.570312 24-8 13.855469zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m28.152344 126.929688 8-13.855469 41.570312 23.996093-8 13.859376zm0 0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m432 232h48v16h-48zm0 0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m0 232h48v16h-48zm0 0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m402.28125 137.070312 41.570312-23.996093 8 13.855469-41.574218 23.996093zm0 0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m28.15625 353.070312 41.570312-23.996093 8 13.859375-41.574218 23.996094zm0 0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m329.070312 69.722656 24-41.570312 13.855469 8-24 41.570312zm0 0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m113.066406 443.847656 23.996094-41.574218 13.859375 8-23.996094 41.570312zm0 0"
});

var SvgLightMode = function SvgLightMode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "0 0 480 480",
    width: "480pt",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightMode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/light-mode.4b061cf6.svg";
export { ForwardRef as ReactComponent };